export default __webpack_public_path__ + "static/media/folder.6e4f5988.svg";